import './HeaderViewer.css';

type HeaderViewerProps = {
  logo?: string;
  background?: string;
  bgColor: string | null | undefined;
}

export const HeaderViewer = ({ logo, background, bgColor }: HeaderViewerProps) => {
  return (
    <div
      className="hv-main-container"
      style={{
        backgroundColor: background ? 'transparent' : (bgColor ?? 'transparent'),
        backgroundImage: background ? `url(${background})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="hv-image-section">
        {logo && (
          <img
            loading="lazy"
            src={logo}
            className="hv-image"
            alt="logo"
          />
        )}
      </div>
    </div>
  )
}